module.exports = __webpack_public_path__ + "media/images/footer_note-af0da5a024dac7ece42fc8c6a126084c.svg";